<template>
    <div id="app">
        <div class="pc-box">
            <Header/>
            <Banner/>
            <div class="content">
                <div class="content-left">
                    <router-view/>
                </div>
                <div class="content-right">
                    <ContentR/>
                </div>
            </div>
            <Suspension/>
            <Footer/>
            <Mobile/>
        </div>
    </div>
</template>

<script>
import { Header } from 'shared'
import { Banner } from 'shared'
import ContentR from './views/ContentR'
import Footer from './views/Footer'
import { Suspension } from 'shared'
import { Mobile } from 'shared'

export default {
    components: {
        Header,
        Banner,
        ContentR,
        Footer,
        Suspension,
        Mobile
    },
    created() {
        this.$store.commit('getTaiwan', 'sec')
        this.$store.dispatch('getBannerZt', '社交')
        this.$store.dispatch('getBannerArticle', '社交')
        this.$store.commit('getSubmit', '社交电商')
        this.$store.commit('dataColor', {
            bar0: '#fe0202',
            bar1: '#fca835',
            line0: '#3d8bf0',
            line1: '#cce2ff'
        })
        this.$store.commit('getType', 10)
    },
}
</script>

<style>
#app .right-box .form .btn:hover {
    color: #fff;
    background-color: #fe0202;
    border-color: #fe0202;
}

.company h2::before,
.content-right .platform li:hover,
.move-searchBox,
.report-con .report-title p,
.report-list li a:hover .report-con,
.tsb a:hover span {
    background: #fe0202;
}

.el-menu--horizontal .el-menu .el-menu-item:hover {
    color: #fe0202 !important;
    background: #eee !important;
}
.el-menu--horizontal .el-menu .el-menu-item:hover span {
    color: #fe0202 !important;
}

.content-left .title {
    border-left: 5px solid #fe0202;
}
.content-left .title h2 span {
    color: #fe0202;
    padding: 0 10px;
}

.content-right .right-title a:hover,
.company-title a:hover,
#app .right-box .form .btn,
.text a:hover span,
.content-left .more a,
.project a:hover p,
.report-list li a:hover .report-title p,
.tsb a:hover p,
.mobile-bottom .current,
.mobile-top .current2,
.mobile-submit i,
.backtop:hover,
.code-box:hover {
    color: #fe0202;
}

@media(max-width: 868px) {
  .banner-right .banner-right-m p {
    background: #fe0202;
  }
}
</style>